//import GoogleSpreadsheet from 'google-spreadsheet'

//TODO: If this gets big user store
let cache = []
function isEmptyOrSpaces(str) {
    return str == null || str.match(/^\s*$/) !== null;
}

export async function LoadTopicDataFromGoogleSheet(sheetsURL) {
    let cacheData=checkForCache(sheetsURL)
    var separateByLine = (await (await cacheData.data).clone().text()).split('\r\n');
    var topicIndex = -1,
        startIndex = -1,
        endIndex = -1,
        createNewObject = true;
    var dataArray = [];
    separateByLine.forEach(element => {
        if (isEmptyOrSpaces(element)) {
            topicIndex = -1;
            startIndex = -1;
            endIndex = -1;
            createNewObject = true;
            return;
        }
        var splitted = element.split('\t');
        if (topicIndex != -1) {
            if (createNewObject) {
                dataArray.push({
                    "Topic": [],
                    "start": [],
                    "end": [],
                })
            }
            dataArray[dataArray.length - 1].Topic.push(splitted[topicIndex]);
            dataArray[dataArray.length - 1].start.push(splitted.length > startIndex ? splitted[startIndex] : null);
            dataArray[dataArray.length - 1].end.push(splitted.length > endIndex ? splitted[endIndex] : null);
            createNewObject = null;
        } else {
            topicIndex = splitted.findIndex(x => x == "Topic");
            startIndex = splitted.findIndex(x => x == "start");
            endIndex = splitted.findIndex(x => x == "end");
        }
    });
    return dataArray;
}


export async function LoadDesktopTopicDataFromGoogleSheet(sheetsURL) {
    let cacheData=checkForCache(sheetsURL)
    var separateByLine = (await (await cacheData.data).clone().text()).split('\r\n');
    var topicIndex = -1,
        startIndex = -1,
        endIndex = -1,
        personIndex = -1,
        createNewObject = true;
    var dataArray = [];
    separateByLine.forEach(element => {
        if (isEmptyOrSpaces(element)) {
            topicIndex = -1;
            startIndex = -1;
            endIndex = -1;
            personIndex = -1;
            createNewObject = true;
            return;
        }
        var splitted = element.split('\t');
        if (topicIndex != -1) {
            if (createNewObject) {
                dataArray.push({
                    "Topic": [],
                    "start": [],
                    "end": [],
                    "person": []
                })
            }
            dataArray[dataArray.length - 1].Topic.push(splitted[topicIndex]);
            dataArray[dataArray.length - 1].start.push(splitted.length > startIndex ? splitted[startIndex] : null);
            dataArray[dataArray.length - 1].end.push(splitted.length > endIndex ? splitted[endIndex] : null);
            dataArray[dataArray.length - 1].person.push(splitted.length > personIndex ? splitted[personIndex] : null);
            createNewObject = null;
        } else {
            topicIndex = splitted.findIndex(x => x == "Topic");
            startIndex = splitted.findIndex(x => x == "start");
            endIndex = splitted.findIndex(x => x == "end");
            personIndex = splitted.findIndex(x => x == "Person");
        }
    });

    let formattedData = []
    for(let i=0;i<dataArray.length;i++){
        let data= {
            "Title":dataArray[i].Topic[0],
            "start":dataArray[i].start[0],
            "end":dataArray[i].end[0],
            "Person":dataArray[i].person[0],
            "subTopics":[]
        }
        for(let j=1;j<dataArray[i].Topic.length;j++){
            data.subTopics.push({
                "Title":dataArray[i].Topic[j],
                "start":dataArray[i].start[j],
                "end":dataArray[i].end[j],
                "Person":dataArray[i].person[j]
            })
        }
        formattedData.push(data)
    }
    return formattedData;
}

export async function LoadPulicationDataFromGoogleSheet(sheetsURL) {
    let cacheData=checkForCache(sheetsURL)
    var separateByLine = (await (await cacheData.data).clone().text()).split('\r\n');
    var dataArray = [],
        i;
    for (i = 1; i < separateByLine.length; i++) {
        var line = separateByLine[i].split('\t');
        for (var j = 0; j < line.length; j++) {
            if (i == 1) {
                dataArray.push([]);
            }
            dataArray[j].push(line[j])
        }

    }
    var ouputData = {};
    var firstLine = separateByLine[0].split('\t');
    for (i = 0; i < firstLine.length; i++) {
        ouputData[firstLine[i].toLowerCase()] = dataArray[i];
    }
    return ouputData;
}

function checkForCache(url){
    let data = cache.find(x=>x.url === url)
    if(data!=null){
        return data
    }
    else{
        let cacheData = {'url':url, 'data':null,'isDataLoading':true}
        cache.push(cacheData)
        cacheData.data = fetch(url);
        return cacheData
    }
}

/*
export function LoadDataFromGoogleSheet(googleDocId, sheetName) {
    return new Promise(function(resolve, reject) {
        var doc = new GoogleSpreadsheet(googleDocId, null, { gzip: false });
        var sheet;
        doc.getInfo(function(err, info) {
            if (err) console.log(err)
            sheet = info.worksheets.filter((sheet) => {
                return sheet.title == sheetName
            })
            if (sheet == null) {
                console.error(`No sheet found with name ${sheetName} in specified GoogleSheet`);
            } else {
                sheet = sheet[0]
            }
            //console.log('sheet 1: '+sheet.title+' '+sheet.rowCount+'x'+sheet.colCount);
            sheet.getRows({
                offset: 1,
                limit: 2000,
                orderby: 'col2'
            }, function(err, rows) {
                resolve(rows);
            });
        });
    })
}
*/
